import React, { useState } from 'react';
import { IContatoCircularizacao } from '../interfaces/ICircularizacao';

interface Props {
  contato?: IContatoCircularizacao;
  salvando: boolean;
  onCancelar: () => void;
  onConfirmar: (dados: Omit<IContatoCircularizacao, 'id'> & { id?: string }) => void;
}

const REGEX_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Seção 6.1/6.2 — campos obrigatórios (Nome, E-mail, Telefone) e complementares do contato
// responsável pelo recebimento da carta.
const ContatoFormModal: React.FC<Props> = ({ contato, salvando, onCancelar, onConfirmar }) => {
  const [nomeCompleto, setNomeCompleto] = useState(contato?.nomeCompleto ?? '');
  const [emailPrincipal, setEmailPrincipal] = useState(contato?.emailPrincipal ?? '');
  const [telefone, setTelefone] = useState(contato?.telefone ?? '');
  const [cargo, setCargo] = useState(contato?.cargo ?? '');
  const [departamento, setDepartamento] = useState(contato?.departamento ?? '');
  const [telefoneAlternativo, setTelefoneAlternativo] = useState(contato?.telefoneAlternativo ?? '');
  const [emailAlternativo, setEmailAlternativo] = useState(contato?.emailAlternativo ?? '');
  const [observacoes, setObservacoes] = useState(contato?.observacoes ?? '');
  const [contatoPrincipal, setContatoPrincipal] = useState(contato?.contatoPrincipal ?? false);
  const [tentouEnviar, setTentouEnviar] = useState(false);

  const emailValido = REGEX_EMAIL.test(emailPrincipal.trim());
  const valido = nomeCompleto.trim().length > 0 && emailValido && telefone.trim().length > 0;

  const confirmar = () => {
    setTentouEnviar(true);
    if (!valido) return;
    onConfirmar({
      id: contato?.id,
      nomeCompleto: nomeCompleto.trim(),
      emailPrincipal: emailPrincipal.trim(),
      telefone: telefone.trim(),
      cargo: cargo.trim() || undefined,
      departamento: departamento.trim() || undefined,
      telefoneAlternativo: telefoneAlternativo.trim() || undefined,
      emailAlternativo: emailAlternativo.trim() || undefined,
      observacoes: observacoes.trim() || undefined,
      contatoPrincipal,
    });
  };

  return (
    <div className='circ-modal-backdrop' onMouseDown={(e) => e.target === e.currentTarget && onCancelar()}>
      <div className='circ-modal'>
        <div className='circ-modal-header'>
          <h4>{contato ? 'Editar Contato' : 'Novo Contato'}</h4>
          <button type='button' className='btn btn-sm btn-icon btn-light' aria-label='Fechar' onClick={onCancelar}>
            <i className='bi bi-x-lg' />
          </button>
        </div>
        <div className='circ-modal-body'>
          <div className='circ-form-group'>
            <label className='circ-campo-obrigatorio'>Nome Completo</label>
            <input className='circ-form-control' value={nomeCompleto} onChange={(e) => setNomeCompleto(e.target.value)} />
          </div>
          <div className='row g-2'>
            <div className='col-md-6 circ-form-group'>
              <label className='circ-campo-obrigatorio'>E-mail Principal</label>
              <input
                className='circ-form-control'
                value={emailPrincipal}
                onChange={(e) => setEmailPrincipal(e.target.value)}
                placeholder='nome@empresa.com.br'
              />
              {tentouEnviar && !emailValido && (
                <div className='text-danger mt-1' style={{ fontSize: 12 }}>Informe um e-mail válido.</div>
              )}
            </div>
            <div className='col-md-6 circ-form-group'>
              <label className='circ-campo-obrigatorio'>Telefone</label>
              <input className='circ-form-control' value={telefone} onChange={(e) => setTelefone(e.target.value)} placeholder='(00) 00000-0000' />
            </div>
          </div>
          <div className='row g-2'>
            <div className='col-md-6 circ-form-group'>
              <label>Cargo</label>
              <input className='circ-form-control' value={cargo} onChange={(e) => setCargo(e.target.value)} />
            </div>
            <div className='col-md-6 circ-form-group'>
              <label>Departamento</label>
              <input className='circ-form-control' value={departamento} onChange={(e) => setDepartamento(e.target.value)} />
            </div>
          </div>
          <div className='row g-2'>
            <div className='col-md-6 circ-form-group'>
              <label>Telefone Alternativo</label>
              <input className='circ-form-control' value={telefoneAlternativo} onChange={(e) => setTelefoneAlternativo(e.target.value)} />
            </div>
            <div className='col-md-6 circ-form-group'>
              <label>E-mail Alternativo</label>
              <input className='circ-form-control' value={emailAlternativo} onChange={(e) => setEmailAlternativo(e.target.value)} />
            </div>
          </div>
          <div className='circ-form-group'>
            <label>Observações</label>
            <textarea className='circ-form-control' rows={2} value={observacoes} onChange={(e) => setObservacoes(e.target.value)} />
          </div>
          <div className='form-check'>
            <input
              id='circ-contato-principal'
              type='checkbox'
              className='form-check-input'
              checked={contatoPrincipal}
              onChange={(e) => setContatoPrincipal(e.target.checked)}
            />
            <label htmlFor='circ-contato-principal' className='form-check-label' style={{ fontSize: 13 }}>
              Definir como contato principal
            </label>
          </div>
        </div>
        <div className='circ-modal-footer'>
          <button type='button' className='btn btn-sm btn-light' disabled={salvando} onClick={onCancelar}>
            Cancelar
          </button>
          <button type='button' className='btn btn-sm btn-primary' disabled={salvando} onClick={confirmar}>
            {salvando && <span className='spinner-border spinner-border-sm me-1' />}
            Salvar Contato
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContatoFormModal;
